<section class="mu-home font-size-14" *ngIf="activityDetailsForm">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <form [formGroup]="activityDetailsForm">
            <div class="row">
              <div class="col-md-12 text-end">
                <a
                  *ngIf="activity?.name === 'New Joinee Workflow' && activity?.status !== 'COMPLETED'"
                  class="me-1">
                  <button type="button" class="btn-actvtytp" (click)="goToNewJoineeActivity()">Go to Workflow</button>
                </a>
                <a>
                  <button type="button" class="btn-actvtytp" (click)="downloadActivity()">DOWNLOAD</button>
                </a>
              </div>
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3 class="mb-0">View/Update Activity Details</h3>
              </div>
              <div class="row row-cols-6">
                <div class="col-md-6 col-12">
                  <div class="row p-2">
                    <div class="col-4">Activity ID</div>
                    <div class="col">{{ f.displayId.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Activity Name</div>
                    <div class="col">{{ f.name.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Category</div>
                    <div class="col">{{ this.activity?.taskCategory }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Sub Category</div>
                    <div class="col">{{ this.activity?.taskSubCategory }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Description</div>
                    <div class="col" style="white-space: pre-line; word-break: break-all">
                      {{ f.description.value }}
                    </div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Type of Activity</div>
                    <div class="col">{{ f.activityType.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Days Elapsed</div>
                    <div class="col">{{ f.daysElapsed.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Request Initiated On</div>
                    <div class="col">{{ f.createdDatetime.value }}</div>
                  </div>
                  <div *ngIf="user?.userType === userType.EMPLOYEE_ADMIN" class="row p-2">
                    <div class="col-4">Response Due by</div>
                    <div class="col">{{ f.responseDueDatetime.value }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="p-2">
                        <label for="exampleFormControlTextarea1" class="form-label">Detailed Status</label>
                        <textarea
                          class="form-control"
                          id="exampleFormControlTextarea1"
                          rows="1"
                          formControlName="detailedStatus"></textarea>
                      </div>
                      <app-validation
                        field="detailedStatus"
                        [form]="activityDetailsForm"
                        [error]="{
                          minLength: 'Detailed status should have minimum 6 characters.',
                          maxLength: 'Detailed status can have maximum 255 characters.'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <app-assign-to-selector
                          [selectedId]="activity?.assignedTo"
                          [mandatory]="false"
                          [includeInactives]="true"
                          (selectedValueChange)="handleAssignToSelectedValue($event)"></app-assign-to-selector>
                      </div>
                    </div>
                    <div *ngIf="user?.userType === userType.RMS_ADMIN" class="col-md-6 col-12">
                      <div class="p-2">
                        <label for="responseDueDatetimeInput1" class="form-label">Response Due by </label>
                        <input
                          id="responseDueDatetimeInput1"
                          type="date"
                          class="form-control"
                          formControlName="responseDueDatetime" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <label for="location_activity" class="form-label">Location</label>
                        <select
                          class="form-select"
                          id="location_activity"
                          aria-label="Default select example"
                          [formControlName]="LOCATION_CONTROL_NAME">
                          <option selected value="">Select Location</option>
                          <option *ngFor="let location of locationOptions | keyvalue" [value]="location.key">
                            {{ location.value }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <app-status-selector
                          [selectedStatus]="activity?.status"
                          [categoryName]="activity?.taskCategory"
                          [subCategoryName]="activity?.taskSubCategory"
                          [moduleName]="MODULENAME"
                          [code]="activity?.taskCode"
                          [isRequired]="true"
                          (onSelect)="onStatusSelected($event)"
                          (onStatusChange)="onStatusChange($event)">
                        </app-status-selector>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="isHeadcountRequired">
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <label for="headcount_activity" class="form-label">Headcount</label>
                        <input
                          id="headcount_activity"
                          type="text"
                          inputmode="numeric"
                          class="form-control"
                          maxlength="5"
                          formControlName="headcount"
                          [ngClass]="{ 'is-invalid': f['headcount'].errors && f['headcount'].touched }" />
                        <app-validation
                          field="headcount"
                          [form]="activityDetailsForm"
                          [error]="{
                            maxLength: 'Headcount should not exceed 5 characters.',
                            pattern: 'Headcount should contain numbers only.'
                          }"></app-validation>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="activity?.name === 'New Joinee Workflow'" class="switch-group">
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <h6 class="switch-heading">Previous EPF</h6>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="p-2">
                          <app-switch
                            [value]="activity?.havePfAccount"
                            (valueChange)="handleNewJoineeActvitySwitchValue($event, 'PREVIOUS_EPF')"></app-switch>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <h6 class="switch-heading">EPS</h6>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="p-2">
                          <app-switch
                            [value]="activity?.isMemberOfEmployeePensionScheme"
                            (valueChange)="handleNewJoineeActvitySwitchValue($event, 'MEM_OF_EPS')"></app-switch>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <h6 class="switch-heading">IW Status</h6>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="p-2">
                          <app-switch
                            [value]="activity?.isInternationalWorker"
                            (valueChange)="handleNewJoineeActvitySwitchValue($event, 'IW_STATUS')"></app-switch>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 col-12">
                        <h6 class="switch-heading">PF portal Status</h6>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="p-2">
                          <app-switch
                            [value]="activity?.pfPortalStatus"
                            (valueChange)="handleNewJoineeActvitySwitchValue($event, 'PF_PORTAL_STATUS')"></app-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div *ngIf="isEmployeeLinkedTask" class="accordion" id="employeeDetailsAccordion">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="employeeDetailsHeading">
                        <button
                          class="side-panel-label accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#employeeDetailsContent"
                          aria-expanded="true"
                          aria-controls="employeeDetailsContent">
                          Employee Details
                        </button>
                      </h2>
                      <div
                        id="employeeDetailsContent"
                        class="collapsed collapse"
                        aria-labelledby="employeeDetailsHeading"
                        data-bs-parent="#employeeDetailsAccordion">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-4">Employee Code</div>
                            <div class="col">{{ f.ownerDisplayId?.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee Name</div>
                            <div class="col">{{ f.empName?.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee Status</div>
                            <div class="col">{{ f.empStatus?.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee PF Number</div>
                            <div class="col">{{ f.empCurrentPfNumber?.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee UAN Number</div>
                            <div class="col">{{ f.empUanNumber?.value }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <app-comment
                      [comments]="activity?.comments"
                      (add)="addComment($event)"
                      [statusChange]="statusValueChange"
                      (mandatoryflag)="mandatoryflag($event)"
                      (notifyChange)="getIfNotifySelected($event)"></app-comment>
                  </div>
                  <div class="col-12">
                    <p class="side-panel-label">Upload Documents</p>
                    <app-multiple-file-selector
                      [maxAllowedSizeInMB]="7"
                      [enableMultiSelect]="true"
                      [allowedTypes]="[
                        'application/pdf',
                        'text/plain',
                        'image/jpeg',
                        'image/png',
                        'application/vnd.ms-excel',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'message/rfc822',
                        'application/vnd.ms-excel.sheet.macroenabled.12'
                      ]"
                      (chooseFiles)="handleFileInput($event)"
                      (removeFiles)="clearSelectedFiles($event)"></app-multiple-file-selector>
                  </div>
                  <div class="col-12">
                    <div class="p-2">
                      <app-attachment-list
                        [referenceId]="id"
                        [canDownloadAll]="true"
                        [attachments]="activity?.documents"
                        [companyEntityId]="activity?.companyEntityId"></app-attachment-list>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-end acvtypglastbtn">
                <a>
                  <button
                    type="button"
                    class="btn"
                    (click)="updateActivity()"
                    [disabled]="!activityDetailsForm.valid || isDisabled">
                    SAVE & EXIT
                  </button>
                </a>
                <a>
                  <button type="button" class="btn-discard" [routerLink]="ACTIVITY_SUMMARY_LINK">EXIT</button>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
